import { atom } from "recoil";

const engineState = atom({
  key: "engineState",
  default: {
    text: "gpt-4-1106-preview",
    image: "dall-e-3",
  },
});

export default engineState;